String.prototype.toNumber = function(this: string): number {
    return Number(this);
}

String.prototype.equals = function(this: string, value: string): boolean {
    return this === value;
};

String.isNull = function(value: string|null): boolean {
    return value === null || value.length === 0;
}

String.prototype.capitalizeFirst = function(this: string): string {
    return this.charAt(0).toUpperCase() + this.slice(1);
}